let district = [
    { "x": -1, "y": -1, "type": "right", "opts": "start", "pickup": false },
    { "x": -3, "y": -2, "type": "righttoleft", "pickup": false },
    { "x": -3, "y": -3, "type": "left", "pickup": false },
    { "x": -3, "y": -4, "type": "lefttop", "pickup": false },
    { "x": -4, "y": -5, "type": "top", "pickup": false },
    { "x": -5, "y": -6, "type": "top", "pickup": false },
    { "x": -6, "y": -7, "type": "top", "pickup": false },
    { "x": -7, "y": -8, "type": "top", "pickup": false },
    { "x": -8, "y": -9, "type": "top", "pickup": false },
    { "x": -9, "y": -10, "type": "top", "pickup": false },
    { "x": -10, "y": -11, "type": "top", "pickup": false },
    { "x": -11, "y": -12, "type": "top", "pickup": false },
    { "x": -12, "y": -13, "type": "top", "pickup": false },
    { "x": -13, "y": -14, "type": "top", "pickup": false },
    { "x": -14, "y": -15, "type": "top", "pickup": false },
    { "x": -15, "y": -16, "type": "top", "pickup": false },
    { "x": -16, "y": -17, "type": "top", "pickup": false },
    { "x": -17, "y": -18, "type": "top", "pickup": false },
    { "x": -18, "y": -19, "type": "top", "pickup": false },
    { "x": -19, "y": -20, "type": "top", "pickup": false },
    { "x": -20, "y": -21, "type": "top", "pickup": false },
    { "x": -21, "y": -22, "type": "top", "pickup": false },
    { "x": -22, "y": -23, "type": "top", "pickup": false },
    { "x": -23, "y": -24, "type": "top", "pickup": false },
    { "x": -24, "y": -25, "type": "top", "pickup": false },
    { "x": -25, "y": -26, "type": "top", "pickup": false },
    { "x": -26, "y": -27, "type": "top", "pickup": false },
    { "x": -27, "y": -28, "type": "top", "pickup": false },
    { "x": -28, "y": -29, "type": "top", "pickup": false },
    { "x": -29, "y": -30, "type": "top", "pickup": false },
    { "x": -30, "y": -31, "type": "top", "pickup": false },
    { "x": -31, "y": -32, "type": "topright", "opts": "end", "pickup": false }
];

export default district;